import React from "react";
import "./scrollCardsInfo.css";

const ScrollCardsInfo = ({
  number,
  headingOne,
  contentOne,
  contentTwo,
  contentThree,
  contentFour,
}) => {
  return (
    <>
      <div className="">
        <div className="tes-scr">
          <div>
            <h3 className="scroll-cards-heading-style">{headingOne} </h3>
          </div>
          <div className="cards-content-section">
            <p>{contentOne}</p>
            <p>{contentTwo}</p>
            <p>{contentThree}</p>
            <p>{contentFour}</p>
          </div>
        </div>
      </div>
    </>
  );
};
export default ScrollCardsInfo;
